// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import VueAxios from 'vue-axios'
import VueAuthenticate from 'vue-authenticate'
import axios from 'axios'
import Vuex from 'vuex'
import Snotify, { SnotifyPosition } from 'vue-snotify'
import 'vue-snotify/styles/material.css'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { getRedirectUri } from './utils/constants'
import vSelect from 'vue-select'
import VeeValidate from 'vee-validate'
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import InfiniteLoading from 'vue-infinite-loading'
import vueMoment from 'vue-moment'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
import StarRating from 'vue-star-rating'
import VueMaterial from 'vue-material'
import VueScrollTo from 'vue-scrollto'
import VuejsDialog from 'vuejs-dialog'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vuejs-dialog/dist/vuejs-dialog.min.css'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import '@/assets/static/css/main.scss'
import { interceptorsConfig } from '@/utils/request'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueTelInput from 'vue-tel-input'
import { registerMessageFirebase } from '@/firebase/config'
import './utils/filter'
import Raters from 'vue-rate-it'
import VueGtag from 'vue-gtag'
import VueCardFormat from 'vue-credit-card-validation'

registerMessageFirebase()
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_API_KEY,
    libraries: 'places'
  }
})
Vue.use(PerfectScrollbar)
Vue.use(VueMaterial)
Vue.use(VueScrollTo)
Vue.use(VuejsDialog)
Vue.component('star-rating', StarRating)
Vue.component('image-rating', Raters.ImageRating)
Vue.component('v-select', vSelect)
Vue.component('date-picker', DatePicker)
Vue.use(BootstrapVue)
Vue.use(vueMoment)
Vue.use(VueAwesomeSwiper)
Vue.use(VueTelInput)
Vue.use(InfiniteLoading, {
  props: {
    spinner: 'bubbles',
    distance: 500,
    direction: 'top'
    /* other props need to configure */
  },
  system: {
    /* other settings need to configure */
  }
})
Vue.use(VueVideoPlayer)
Vue.use(VeeValidate, {
  events: 'blur',
  fieldsBagName: 'veeFields'
})
Vue.use(VueGtag, {
  config: {
    id: 'UA-219973146-1'
  }
})
Vue.use(VueAxios, axios)
Vue.use(Vuex)
Vue.use(Loading)
Vue.use(interceptorsConfig)
vSelect.props.components.default = () => ({
  Deselect: {
    render: (createElement) => createElement('span', '✖️')
  },
  OpenIndicator: {
    render: (createElement) => createElement('span', '«')
  }
})
Vue.use(Snotify, {
  toast: {
    position: SnotifyPosition.rightTop,
    showProgressBar: false,
    timeout: 3000
  }
})

Vue.use(VueCardFormat)
Vue.use(VueAuthenticate, {
  baseUrl: process.env.VUE_APP_API_URL, // Your API domain
  tokenName: 'key',

  providers: {
    facebook: {
      clientId: process.env.FACEBOOK_CLIENT_ID,
      url: '/auth/facebook',
      responseType: 'token',
      auth_uri: 'https://www.facebook.com/v2.5/dialog/oauth',
      redirectUri: getRedirectUri('/'),
      requiredUrlParams: ['display', 'scope'],
      scope: ['email'],
      scopeDelimiter: ',',
      display: 'popup',
      oauthType: '2.0',
      popupOptions: { width: 580, height: 400 },
      requestDataKey: 'data',
      responseDataKey: 'data'
    },
    google: {
      clientId: process.env.GOOGLE_CLIENT_ID,
      url: '/auth/google/',
      auth_uri: 'https://accounts.google.com/o/oauth2/auth',
      redirectUri: getRedirectUri(),
      requiredUrlParams: ['scope'],
      optionalUrlParams: ['display'],
      scope: ['profile', 'email'],
      scopePrefix: 'openid',
      scopeDelimiter: ' ',
      display: 'popup',
      oauthType: '2.0',
      popupOptions: { width: 452, height: 633 },
      requestDataKey: 'data',
      responseDataKey: 'data',
      responseType: 'token'
    }
  }
})

Vue.config.productionTip = false

Vue.directive('click-outside', {
  bind: function(el, binding, vnode) {
    el.clickOutsideEvent = function(event) {
      if (!(el === event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event)
      }
    }
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})
